import { render, staticRenderFns } from "./q-print.vue?vue&type=template&id=52b0884a&scoped=true&"
import script from "./q-print.vue?vue&type=script&lang=js&"
export * from "./q-print.vue?vue&type=script&lang=js&"
import style0 from "./q-print.vue?vue&type=style&index=0&id=52b0884a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0884a",
  null
  
)

export default component.exports